export const MIN_SPRAY_COUNT = 1
export const MAX_SPRAY_COUNT = 30

export function normalizeSprayCount(value) {
  if (value === '' || value == null) return null
  const parsed = Number(value)
  if (!Number.isInteger(parsed) || parsed < MIN_SPRAY_COUNT || parsed > MAX_SPRAY_COUNT) return null
  return parsed
}

export function resolveSprayPrefill({ fragranceOverride = null, userDefault = null } = {}) {
  return normalizeSprayCount(fragranceOverride)
    ?? normalizeSprayCount(userDefault)
    ?? ''
}

export function significantDateContext(dates = [], selectedId = null) {
  if (!selectedId) return null
  const selected = dates.find(item => item.id === selectedId)
  if (!selected) return null
  return {
    id: selected.id,
    label: selected.label,
    canonicalTag: 'event',
  }
}
